import axiosInstance from './axiosInstance';

const generalService = {
  getInitialData: async (data) => {
    try {
        const response = await axiosInstance.post('/general/initial-data', data || {});
        return response.data;
    } catch (error) {
      console.error('Error getting initial data:', error.response?.data || error.message);
      throw error;
    }
  },
  deleteConnection: async (connection) => {
    try {
        const response = await axiosInstance.post('/connections/delete-connection', {type: connection} || {});
        return response.data;
    } catch (error) {
      console.error('Error deleting connection:', error.response?.data || error.message);
      throw error;
    }
  },
};

export default generalService;
